import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getContent } from '../api';
import AboutUs from '../components/AboutUs';
import News from '../components/News';
import Services from '../components/Services';
import Contacts from '../components/Contacts';
import NavBar from '../components';
import Loading from '../components/Loading';
import i18n from '../locales/i18n';

export default function UserPage({ isAdmin }) {
  const [about, setAbout] = useState(null);
  const [services, setServices] = useState(null);
  const [news, setNews] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [mainImg, setMainImg] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    getContent()
      .then((res) => {
        setAbout(res.data.about);
        setServices(res.data.services);
        setNews(res.data.news);
        setContacts(res.data.contacts);
        setMainImg(res.data.main);
        setState('success');
      })
      .catch();
  }, []);

  if (state === 'loading') {
    return (
      <div>
        {mainImg && <Loading />}
      </div>
    );
  }

  return (
    <div>
      { mainImg && <NavBar isAdmin={isAdmin} mainImg={mainImg} style={{ height: '100vh' }} />}
      <div className="main">
        <div className="grid-container">
          {about && <AboutUs text={about.text[i18n.language]} />}
          {news && <News newsList={news} />}
          {services && <Services servicesList={services} />}
        </div>
        <div />
      </div>
      {contacts && (
        <Contacts
          email={contacts.email}
          mobile={contacts.mobile}
          telephone={contacts.telephone}
          address={contacts.address}
          postalcode={contacts.postalcode}
          facebook={contacts.facebook}
          linkedin={contacts.linkedin}
          linkMaps={contacts.linkMaps}
          isAdmin
        />
      )}
    </div>
  );
}

UserPage.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
};
